var subscribe = function subscribe() {
  var listener = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (source) {
    if (typeof listener === "function") {
      listener = {
        next: listener
      };
    }

    var _listener = listener,
        next = _listener.next,
        error = _listener.error,
        complete = _listener.complete;
    var talkback;
    source(0, function (t, d) {
      if (t === 0) {
        talkback = d;
      }

      if (t === 1 && next) next(d);
      if (t === 1 || t === 0) talkback(1); // Pull

      if (t === 2 && !d && complete) complete();
      if (t === 2 && !!d && error) error(d);
    });

    var dispose = function dispose() {
      if (talkback) talkback(2);
    };

    return dispose;
  };
};

export default subscribe;